import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { NavbarComponent } from '../app/components/navbar/navbar';
import { FooterComponent } from '../app/components/footer/footer';
import { MetaPixelService } from './service/meta-pixel.service';
import { AnalyticsService } from './service/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent implements OnDestroy {
  showCookieBanner = true;
  private readonly routerSubscription: Subscription;
  private skipInitialPageView: boolean;
  private skipInitialAnalyticsPageView: boolean;

  constructor(
    private router: Router,
    private metaPixel: MetaPixelService,
    private analytics: AnalyticsService
  ) {
    this.showCookieBanner = !this.metaPixel.hasChoice;
    this.skipInitialPageView = this.metaPixel.isAccepted;
    this.skipInitialAnalyticsPageView = this.analytics.isAccepted;
    this.metaPixel.initFromSavedConsent();
    this.analytics.initFromSavedConsent();

    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (this.skipInitialPageView) {
          this.skipInitialPageView = false;
        } else {
          this.metaPixel.trackPageView();
        }

        if (this.skipInitialAnalyticsPageView) {
          this.skipInitialAnalyticsPageView = false;
        } else {
          this.analytics.trackPageView(event.urlAfterRedirects);
        }
      });
  }

  @HostListener('document:click', ['$event'])
  trackContactClick(event: MouseEvent): void {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const href = target.closest('a')?.getAttribute('href') || '';
    if (href.startsWith('tel:')) this.analytics.trackContact('phone');
    else if (/^https:\/\/(wa\.me|api\.whatsapp\.com)(\/|$)/.test(href)) this.analytics.trackContact('whatsapp');
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  acceptCookies(): void {
    this.metaPixel.accept();
    this.analytics.accept();
    this.showCookieBanner = false;
  }

  rejectCookies(): void {
    this.metaPixel.reject();
    this.analytics.reject();
    this.showCookieBanner = false;
  }
}
